<table cdk-table [dataSource]="dataSource$" class="table">

  <ng-container *ngFor="let c of columnDefs;let i = index" [cdkColumnDef]="c.id">
    <th cdk-header-cell *cdkHeaderCellDef (click)="sortBy(c.sortKeys)"
      [ngClass]="{
        'cdk-header-cell_sorted': c.sortKeys && c.sortKeys === sortKey,
        'cdk-header-cell_sorting': c.sortKeys
      }">
      {{ c.title | translate }}
      <ng-container *ngIf="c.sortKeys && sortKey === c.sortKeys">
        <i class="arrowSort {{(sortDirection !== undefined ? 'arrowSort_'+sortDirection : '')}}" svgIcon
          [icon]="'arrow-sort'"></i>
      </ng-container>
    </th>
    <td cdk-cell *cdkCellDef="let row">
      <ng-container *ngIf="(dataSource$ | async)">
        <app-tooltip
          *ngIf="c.tooltipContent !== undefined && c.tooltipContent(row) !== undefined; else cellContentTemplate"
          [hasTooltip]="true"
          [text]="c.tooltipContent(row)"
        >
          <ng-container *ngTemplateOutlet="cellContentTemplate"></ng-container>
        </app-tooltip>
        <ng-template #cellContentTemplate>
          <ng-container *ngIf="c.getAddressArray !== undefined; else cellDisplay">
            <div>
              <span *ngFor="let addr of c.getAddressArray(row)" [innerHTML]="addr | translate"></span>
            </div>
          </ng-container>
          <ng-template #cellDisplay>
            <ng-container *ngIf="c.displayFn === undefined; else customDisplay">
              {{ getCellValue(row, c.id) }}
            </ng-container>
          </ng-template>
          <ng-template #customDisplay>
            <ng-container *ngIf="c.getImagePath === undefined; else displayImage">
              <div [innerHTML]="c.displayFn(row) | translate"></div>
            </ng-container>
          </ng-template>
          <ng-template #displayImage>
            <div class="cdk-cell_hasImage">
              <i *ngIf="c.getImagePath(row); else defaultImage"
                 [style]="'background:url(' +  c.getImagePath(row) + ');background-size:contain;' | noSanitize"></i>
              <ng-template #defaultImage><i></i></ng-template>
              <div [innerHTML]="c.displayFn(row) | translate"></div>
            </div>
          </ng-template>
        </ng-template>
      </ng-container>
    </td>
  </ng-container>

  <ng-content></ng-content>

  <!-- header and body row definitions: which columns to be displayed -->
  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"
    (click)="!(rowDef.isDisabled && rowDef.isDisabled(row)) ? onRowClick(row) : null"
    [ngClass]="{'cdk-row_disabled': rowDef.isDisabled && rowDef.isDisabled(row) }">
  </tr>
</table>
